module.exports = __webpack_public_path__ + "img/iconpassword.4f3c0f13.svg";